import {
  SemanticCOLORS,
  Label as SemanticLabel,
  type LabelProps as SemanticLabelProps,
} from "semantic-ui-react";

type LabelProps = Omit<SemanticLabelProps, "color"> & {
  color?: SemanticCOLORS | "primary" | "secondary";
};

const Label = (props: LabelProps) => {
  return <SemanticLabel {...props} color={props.color as SemanticCOLORS} />;
};

Label.Detail = SemanticLabel.Detail;
Label.Group = SemanticLabel.Group;

export { Label };
